var fowtr_module_read_aloud = (function (fowtr_module_read_aloud) {




    var calculateTime = function(secs) {
      var minutes = Math.floor(secs / 60);
      var seconds = Math.floor(secs % 60);
      var returnedSeconds = seconds < 10 ? "0"+seconds : seconds;
      return minutes+":"+returnedSeconds;
    }

    var displayBufferedAmount = function() {
      // var bufferedAmount = 0;
      // console.log('buffering');
      var bufferedAmount = Math.floor(audio.buffered.end(audio.buffered.length-1));
      // var bufferedAmount = Math.floor(audio.seekable.end(audio.seekable.length - 1));
      audioPlayerContainer[0].style.setProperty('--buffered-width', ((bufferedAmount / seekSlider.max) * 100)+"%");
    }

    // var whilePlaying = function() {
    //   seekSlider.value = Math.floor(audio.currentTime);
    //   currentTimeContainer.html(calculateTime(seekSlider.value));
    //   audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
    //   raf = requestAnimationFrame(whilePlaying);
    // }
    var whilePlaying = function() {
      if(isScrubbing) return;
      seekSlider.value = Math.floor(audio.currentTime);
      currentTimeContainer.html(calculateTime(seekSlider.value));
      audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
    }

    var started = function() {
      audioPlayerContainer.addClass('playing');
      clearInterval(raf);
      raf = setInterval(whilePlaying,50);
    }
    var stopped = function() {
      audioPlayerContainer.removeClass('playing');
      clearInterval(raf);
    }



    var playlistContainer = $('#fowtr-read-aloud-playbar-wrapper .fowtr-read-aloud-playbar .playlist-nav');
    var playlistInner = $('#fowtr-read-aloud-playbar-wrapper .fowtr-read-aloud-playbar .playlist-nav .inner');
    var $seekSlider = $('#fowtr-read-aloud-playbar-wrapper .seek-slider');
    var seekSlider = $seekSlider[0];
    var volumeSlider = $('#fowtr-read-aloud-playbar-wrapper #volume-slider');
    var currentTimeContainer = $('#fowtr-read-aloud-playbar-wrapper .current-time');
    var currentTrackTextElement = $('#fowtr-read-aloud-playbar-wrapper .fowtr-read-aloud-playbar .current-track');
    var audioPlayerWrapper = $('#fowtr-read-aloud-playbar-wrapper');
    var audioPlayerContainer = $('#fowtr-read-aloud-playbar-wrapper .fowtr-read-aloud-playbar');
    var $audio = $('#fowtr-read-aloud-playbar-wrapper audio');
    var durationContainer = $('#fowtr-read-aloud-playbar-wrapper .duration');
    var currentTimeContainer = $('#fowtr-read-aloud-playbar-wrapper .current-time');
    var autoScrollToggle = $('#fowtr-read-aloud-playbar-wrapper .auto-scroll #auto-scroll-toggle');
    // var audioPlayer = $audio[0];
    var audio = $audio[0];
    var lastElement = null;
    var currentSectionReading = 0;
    fowtr_module_read_aloud.isPlaying = false;
    var articleInView = 0;
    var raf = null;
    var isScrubbing = false;
    fowtr_module_read_aloud.autoScroll = true;
    var syncData = [];
    var audioFile;
    var audioTitle;
    var currentChapter = 1;

    var urlAudioTimeParamHasJumped = false;
    var urlAudioSectionParamHasJumped = false;




    fowtr_module_read_aloud.init = function(chapter){
      


      // // check URL for time jumping
      // // var urlAudioTimeParam = fowtr_module_utilities.getUrlParameter('at');
      // var urlAudioSectionParam = fowtr_module_utilities.getUrlParameter('lfh');
      // // if(urlAudioTimeParam!==false && urlAudioTimeParamHasJumped==false){
      // //   urlAudioTimeParamHasJumped = true;
      // // }
      // if(urlAudioSectionParam!==false && urlAudioSectionParamHasJumped==false){
      //   setTimeout(function(){
      //     playFromArticle(urlAudioSectionParam);
      //     urlAudioSectionParamHasJumped = true;
      //   }, 1000);
      // }



      currentChapter = chapter;
      syncData = [];
      audioFile = '';
      
      if(chapter==1) {
        audioFile = 'https://local.dhl-future-of-work-trend-report.com/audio/DHL-Trend-Report-Chp-1-v3.m4a';
        audioTitle = 'What is the \'Future of Work\'?';
        syncData = [
          {'start':0, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'Welcome'},
          {'start':42.564, 'article':3, 'element':'#fowtr-article3 h2', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':44.499, 'article':3, 'element':'#fowtr-article3 p.text-white', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':56.956, 'article':3, 'element':'#fowtr-article3 p.text-yellow', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':68.126, 'article':5, 'element':'#fowtr-article5 p:first-child', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':82.427, 'article':5, 'element':'#fowtr-article5 p:nth-child(2)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':104.341, 'article':5, 'element':'#fowtr-article5 p:nth-child(3)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':122.207, 'article':5, 'element':'#fowtr-article5 p:nth-child(4)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Introduction'},
          {'start':133.352, 'article':5, 'element':'#fowtr-article5 h2', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'3 Forces of Change'},
          {'start':135.7, 'article':6, 'element':'#fowtr-article6 a:first-child', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'3 Forces of Change'},
          {'start':136.99, 'article':6, 'element':'#fowtr-article6 a:nth-child(2)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'3 Forces of Change'},
          {'start':138.399, 'article':6, 'element':'#fowtr-article6 a:nth-child(3)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'3 Forces of Change'},
          {'start':141.048, 'article':7, 'element':'#fowtr-article7 h3', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':143.71, 'article':7, 'element':'#fowtr-article7 h4', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':150.215, 'article':7, 'element':'#fowtr-article7 p:not(.text-red)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':169.225, 'article':7, 'element':'#fowtr-article7 p.text-red', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':175.167, 'article':8, 'element':'#fowtr-article8 .timeline-section1 h3', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':179.114, 'article':8, 'element':'#fowtr-article8 .timeline-section1 p', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':210.719, 'article':8, 'element':'#fowtr-article8 .timeline-section2 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':215.988, 'article':8, 'element':'#fowtr-article8 .timeline-section2 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':221.322, 'article':8, 'element':'#fowtr-article8 .timeline-section3 h3', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':225.176, 'article':8, 'element':'#fowtr-article8 .timeline-section3 p', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':250.01, 'article':8, 'element':'#fowtr-article8 .timeline-section4 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':256.408, 'article':8, 'element':'#fowtr-article8 .timeline-section4 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':262.746, 'article':8, 'element':'#fowtr-article8 .timeline-section5 h3', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':266.456, 'article':8, 'element':'#fowtr-article8 .timeline-section5 p', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':292.962, 'article':8, 'element':'#fowtr-article8 .timeline-section6 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':297.886, 'article':8, 'element':'#fowtr-article8 .timeline-section6 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':304.268, 'article':8, 'element':'#fowtr-article8 .timeline-section7 h3', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':308.151, 'article':8, 'element':'#fowtr-article8 .timeline-section7 p', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':347.012, 'article':8, 'element':'#fowtr-article8 .timeline-section8 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':354.69, 'article':8, 'element':'#fowtr-article8 .timeline-section8 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':359.526, 'article':8, 'element':'#fowtr-article8 .timeline-section9 h3', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':363.781, 'article':8, 'element':'#fowtr-article8 .timeline-section9 p', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':388.768, 'article':8, 'element':'#fowtr-article8 .timeline-section10 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':394.422, 'article':8, 'element':'#fowtr-article8 .timeline-section10 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':399.869, 'article':9, 'element':'#fowtr-article9 p:first-child', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':416.11, 'article':9, 'element':'#fowtr-article9 p:nth-child(2)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':437.079, 'article':10, 'element':'#fowtr-article10 p:first-child', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':468.111, 'article':10, 'element':'#fowtr-article10 p:nth-child(2)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':487.618, 'article':10, 'element':'#fowtr-article10 p:nth-child(3)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics'},
          {'start':498.172, 'article':11, 'element':'#fowtr-article11 .content-panel:first-child', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics Panels'},
          {'start':508.498, 'article':11, 'element':'#fowtr-article11 .content-panel:nth-child(2)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics Panels'},
          {'start':516.618, 'article':11, 'element':'#fowtr-article11 .content-panel:nth-child(3)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics Panels'},
          {'start':524.236, 'article':11, 'element':'#fowtr-article11 .content-panel:nth-child(4)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics Panels'},
          {'start':532.166, 'article':11, 'element':'#fowtr-article11 .content-panel:nth-child(6)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics Panels'},
          {'start':541.608, 'article':11, 'element':'#fowtr-article11 .content-panel:nth-child(7)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Shifting Demographics Panels'},
          {'start':556.637, 'article':12, 'element':'#fowtr-article12 h3', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':560.517, 'article':12, 'element':'#fowtr-article12 h4', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':569.669, 'article':12, 'element':'#fowtr-article12 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':594.455, 'article':12, 'element':'#fowtr-article12 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':619.911, 'article':13, 'element':'#fowtr-article13 p:first-child', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':649.878, 'article':13, 'element':'#fowtr-article13 p:nth-child(2)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':681.406, 'article':13, 'element':'#fowtr-article13 p:nth-child(3)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement'},
          {'start':688.421, 'article':14, 'element':'#fowtr-article14 .content-panel:nth-child(3)', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement Panels'},
          {'start':696.798, 'article':14, 'element':'#fowtr-article14 .content-panel:nth-child(4)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement Panels'},
          {'start':702.32, 'article':14, 'element':'#fowtr-article14 .content-panel:nth-child(5)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement Panels'},
          {'start':708.4485833, 'article':14, 'element':'#fowtr-article14 .content-panel:nth-child(8)', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Technology Advancement Panels'},
          {'start':723.175, 'article':15, 'element':'#fowtr-article15 h3', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':727.986, 'article':15, 'element':'#fowtr-article15 h4', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':737.696, 'article':15, 'element':'#fowtr-article15 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':764.811, 'article':15, 'element':'#fowtr-article15 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':794.531, 'article':16, 'element':'#fowtr-article16 h4', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':798.971, 'article':16, 'element':'#fowtr-article16 svg', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':817.225, 'article':17, 'element':'#fowtr-article17 p', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':856.978, 'article':18, 'element':'#fowtr-article18 h4', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':861.437, 'article':18, 'element':'#fowtr-article18 svg', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':871.3, 'article':19, 'element':'#fowtr-article19 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':913.564, 'article':19, 'element':'#fowtr-article19 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'COVID-19 Pandemic'},
          {'start':927.486, 'article':20, 'element':'#fowtr-article20 h4', 'navitem':true, 'title':'What is the \'Future of Work\'?', 'subtitle':'Recap'},
          // {'start':944.328, 'article':20, 'element':'#fowtr-article20 .ra1', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Recap'},
          {'start':955.612, 'article':20, 'element':'#fowtr-article20 .ra2', 'navitem':false, 'title':'What is the \'Future of Work\'?', 'subtitle':'Recap'},
        ];
      }

      if(chapter==2) {
        audioFile = 'https://local.dhl-future-of-work-trend-report.com/audio/DHL-Trend-Report-Chp-2-v3.m4a';
        audioTitle = 'Insights from Our Global Workforce Survey';
        syncData = [
          {'start':0, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Welcome'},
          {'start':47.810, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Introduction'},
          {'start':51.622, 'article':1, 'element':'#fowtr-article1 h2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Introduction'},
          {'start':63.387, 'article':2, 'element':'#fowtr-article2 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Introduction'},
          {'start':118.699, 'article':2, 'element':'#fowtr-article2 .forklift-animation', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Introduction'},
          {'start':122.980, 'article':3, 'element':'#fowtr-article3 h3', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':122.980, 'article':3, 'element':'#fowtr-article3 h3', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':127.878, 'article':3, 'element':'#fowtr-article3 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':148.441, 'article':4, 'element':'#fowtr-article4 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':148.441, 'article':4, 'element':'#fowtr-article4 h5', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':152.698, 'article':4, 'element':'#fowtr-article4 .row > div:first-child', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':159.219, 'article':4, 'element':'#fowtr-article4 .row > div:last-child', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':171.224, 'article':4, 'element':'#fowtr-article4 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':198.906, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':251.580, 'article':6, 'element':'#fowtr-article6 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':260, 'article':6, 'element':null, 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            $('#fowtr-article6 .chart-selector .selector1').trigger('click');
          }},
          {'start':261.6156042, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="3"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            if(!$('#fowtr-article6 .chart-selector .selector1').hasClass('active')) $('#fowtr-article6 .chart-selector .selector1').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="3"]').trigger('click');
          }},
          {'start':265.215125, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="8"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            if(!$('#fowtr-article6 .chart-selector .selector1').hasClass('active')) $('#fowtr-article6 .chart-selector .selector1').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="8"]').trigger('click');
          }},
          {'start':271.1808542, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="4"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            if(!$('#fowtr-article6 .chart-selector .selector1').hasClass('active')) $('#fowtr-article6 .chart-selector .selector1').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="4"]').trigger('click');
          }},
          {'start':276.005, 'article':6, 'element':null, 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            $('#fowtr-article6 .chart-selector .selector2').trigger('click');
          }},
          {'start':279.049, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="1"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            $('#fowtr-article6 .chart-selector .selector2').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="1"]').trigger('click');
          }},
          {'start':285.910, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="6"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            if(!$('#fowtr-article6 .chart-selector .selector2').hasClass('active')) $('#fowtr-article6 .chart-selector .selector2').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="6"]').trigger('click');
          }},
          {'start':290.106, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="3"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            if(!$('#fowtr-article6 .chart-selector .selector2').hasClass('active')) $('#fowtr-article6 .chart-selector .selector2').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="3"]').trigger('click');
          }},
          {'start':293.69075, 'article':6, 'element':'#fowtr-article6 .map .map-node[data-node-id="9"]', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology', 'action':function(){
            if(!$('#fowtr-article6 .chart-selector .selector2').hasClass('active')) $('#fowtr-article6 .chart-selector .selector2').trigger('click');
            $('#fowtr-article6 .map .map-node[data-node-id="9"]').trigger('click');
          }},



          // {'start':63.38139583, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':118.7440833, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':122.7914583, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':127.7591458, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':148.3937708, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':198.82, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':276.0052083, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':285.8760625, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          // {'start':290.0549583, 'article':5, 'element':'#fowtr-article5 p', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':298.2598125, 'article':6, 'element':'#fowtr-article6 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology','action':function(){
            $('#fowtr-article6 .map .map-node-popup .map-node-popup-close').trigger('click');

          }},
          {'start':342.6476875, 'article':6, 'element':'#fowtr-article6 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':388.2297917, 'article':6, 'element':'#fowtr-article6 .ra3', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':412.2167708, 'article':7, 'element':'#fowtr-article7 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':480.8933958, 'article':7, 'element':'#fowtr-article7 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'The impact of technology'},
          {'start':512.0420625, 'article':8, 'element':'#fowtr-article8 h3', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Adapting to new technologies'},
          {'start':517.588875, 'article':8, 'element':'#fowtr-article8 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Adapting to new technologies'},
          {'start':530.6707917, 'article':9, 'element':'#fowtr-article9 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Adapting to new technologies'},
          {'start':559.6751875, 'article':9, 'element':'#fowtr-article9 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Adapting to new technologies'},
          {'start':585.5657917, 'article':10, 'element':'#fowtr-article10 h3', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':589.338125, 'article':10, 'element':'#fowtr-article10 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':615.0782708, 'article':11, 'element':'#fowtr-article11 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':621.4435, 'article':11, 'element':'#fowtr-article11 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':642.9167083, 'article':11, 'element':'#fowtr-article11 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':666.6049167, 'article':11, 'element':'#fowtr-article11 .ra3', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':674.6777083, 'article':11, 'element':'#fowtr-article11 .operations-box-1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':677.8276042, 'article':11, 'element':'#fowtr-article11 .operations-box-2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':679.789875, 'article':11, 'element':'#fowtr-article11 .operations-box-3', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':686.4092708, 'article':11, 'element':'#fowtr-article11 .office-box-1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':690.3337083, 'article':11, 'element':'#fowtr-article11 .office-box-2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':693.3439375, 'article':11, 'element':'#fowtr-article11 .office-box-3', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':697.2731458, 'article':12, 'element':'#fowtr-article12 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':702.1509583, 'article':12, 'element':'#fowtr-article12 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':724.2321875, 'article':12, 'element':'#fowtr-article12 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':766.8441667, 'article':12, 'element':'#fowtr-article12 .ra3', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Attracting and retaining talent'},
          {'start':779.0643333, 'article':13, 'element':'#fowtr-article13 h3', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Upskilling and training'},
          {'start':783.0376458, 'article':13, 'element':'#fowtr-article13 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Upskilling and training'},
          {'start':797.2214167, 'article':14, 'element':'#fowtr-article14 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Upskilling and training'},
          {'start':841.3628125, 'article':14, 'element':'#fowtr-article14 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Upskilling and training'},
          {'start':856.9211458, 'article':15, 'element':'#fowtr-article15 h3', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':860.4860208, 'article':15, 'element':'#fowtr-article15 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':887.5632083, 'article':16, 'element':'#fowtr-article16 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':891.79625, 'article':16, 'element':'#fowtr-article16 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':899.5412083, 'article':16, 'element':'#fowtr-article16 svg', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':918.6672917, 'article':16, 'element':'#fowtr-article16 .ra2', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':960, 'article':17, 'element':'#fowtr-article17 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':998.2772708, 'article':18, 'element':'#fowtr-article18 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':1003.879708, 'article':18, 'element':'#fowtr-article18 .ra1', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Work preferences'},
          {'start':1082.957979, 'article':19, 'element':'#fowtr-article19 h3', 'navitem':true, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Recap'},
          {'start':1089.509813, 'article':19, 'element':'#fowtr-article19 h4', 'navitem':false, 'title':'Insights from Our Global Workforce Survey', 'subtitle':'Recap'},


        ];
      }

      if(chapter==3) {
        audioFile = 'https://local.dhl-future-of-work-trend-report.com/audio/DHL-Trend-Report-Chp-3-v1.m4a';
        audioTitle = 'An Augmented and Automated Future';
        syncData = [
          {'start':0, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},
          {'start':45.22620833, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':true, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},
          {'start':48.2079375, 'article':1, 'element':'#fowtr-article1 h2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},

          {'start':58.52002083, 'article':2, 'element':'#fowtr-article2 h4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},
          {'start':74.64622917, 'article':2, 'element':'#fowtr-article2 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},
          {'start':103.6958333, 'article':2, 'element':'#fowtr-article2 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},

          {'start':124.7115, 'article':4, 'element':'#fowtr-article4 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},
          {'start':148, 'article':4, 'element':'#fowtr-article4 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Introduction'},
          {'start':195, 'article':4, 'element':'#fowtr-article4 h2', 'navitem':true, 'title':'An Augmented and Automated Future', 'subtitle':'3 Concepts of the Future'},

          {'start':198, 'article':5, 'element':'#fowtr-article5 a:first-child', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'3 Concepts of the Future'},
          {'start':199.6073333, 'article':5, 'element':'#fowtr-article5 a:nth-child(2)', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'3 Concepts of the Future'},
          {'start':201.3640417, 'article':5, 'element':'#fowtr-article5 a:nth-child(3)', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'3 Concepts of the Future'},

          {'start':205.081, 'article':6, 'element':'#fowtr-article6 h3', 'navitem':true, 'title':'An Augmented and Automated Future', 'subtitle':'Augmented Workforce'},
          {'start':207, 'article':6, 'element':'#fowtr-article6 h4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Augmented Workforce'},
          {'start':216.820375, 'article':6, 'element':'#fowtr-article6 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Augmented Workforce'},

          {'start':231.4106667, 'article':7, 'element':'#fowtr-article7 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Augmented Workforce'},

          {'start':265.08725, 'article':8, 'element':'#fowtr-article8 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Augmented Workforce'},

          {'start':306.6221875, 'article':9, 'element':'#fowtr-article9 h3', 'navitem':true, 'title':'An Augmented and Automated Future', 'subtitle':'Automated Workplace'},
          {'start':310.1418333, 'article':9, 'element':'#fowtr-article9 h4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Automated Workplace'},
          {'start':324.8534583, 'article':9, 'element':'#fowtr-article9 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Automated Workplace'},

          {'start':337, 'article':10, 'element':'#fowtr-article10 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Automated Workplace'},

          {'start':381.3627292, 'article':11, 'element':'#fowtr-article11 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Automated Workplace'},

          {'start':433.2700208, 'article':12, 'element':'#fowtr-article12 h3', 'navitem':true, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':436.6058542, 'article':12, 'element':'#fowtr-article12 h4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':451.6729583, 'article':12, 'element':'#fowtr-article12 p', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':481.1969167, 'article':13, 'element':'#fowtr-article13 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':491.2853542, 'article':13, 'element':'#fowtr-article13 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':504.54925, 'article':13, 'element':'#fowtr-article13 .ra3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':523.3320833, 'article':13, 'element':'#fowtr-article13 .ra4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':533.6146042, 'article':13, 'element':'#fowtr-article13 .ra5', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':546.1175208, 'article':13, 'element':'#fowtr-article13 .ra6', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':559.1996042, 'article':13, 'element':'#fowtr-article13 .ra7', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':569.1366875, 'article':14, 'element':'#fowtr-article14 .fowtr-slide1 h3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen', 'action':function(){
            fowtr_module_chapter_3.slider.goTo(0);
          }},
          {'start':571.5449375, 'article':14, 'element':'#fowtr-article14 .fowtr-slide1 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':612.44375, 'article':14, 'element':'#fowtr-article14 .fowtr-slide1 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':662.8320208, 'article':14, 'element':'#fowtr-article14 .fowtr-slide2 h3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen', 'action':function(){
            fowtr_module_chapter_3.slider.goTo(1);
          }},
          {'start':665.3364167, 'article':14, 'element':'#fowtr-article14 .fowtr-slide2 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':700.1409792, 'article':14, 'element':'#fowtr-article14 .fowtr-slide2 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':732.72625, 'article':14, 'element':'#fowtr-article14 .fowtr-slide3 h3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen', 'action':function(){
            fowtr_module_chapter_3.slider.goTo(2);
          }},
          {'start':734.9787083, 'article':14, 'element':'#fowtr-article14 .fowtr-slide3 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':767.5064375, 'article':14, 'element':'#fowtr-article14 .fowtr-slide3 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':795.4104375, 'article':14, 'element':'#fowtr-article14 .fowtr-slide4 h3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen', 'action':function(){
            fowtr_module_chapter_3.slider.goTo(3);
          }},
          {'start':797.8170625, 'article':14, 'element':'#fowtr-article14 .fowtr-slide4 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':842.347625, 'article':14, 'element':'#fowtr-article14 .fowtr-slide4 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':874.6160833, 'article':14, 'element':'#fowtr-article14 .fowtr-slide5 h3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen', 'action':function(){
            fowtr_module_chapter_3.slider.goTo(4);
          }},
          {'start':876.6367292, 'article':14, 'element':'#fowtr-article14 .fowtr-slide5 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':937.2383125, 'article':14, 'element':'#fowtr-article14 .fowtr-slide5 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':960.6240208, 'article':14, 'element':'#fowtr-article14 .fowtr-slide6 h3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen', 'action':function(){
            fowtr_module_chapter_3.slider.goTo(5);
          }},
          {'start':963.3080833, 'article':14, 'element':'#fowtr-article14 .fowtr-slide6 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},
          {'start':1002.302875, 'article':14, 'element':'#fowtr-article14 .fowtr-slide6 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Future Forseen'},

          {'start':1037.219125, 'article':15, 'element':'#fowtr-article15 h3', 'navitem':true, 'title':'An Augmented and Automated Future', 'subtitle':'Recap'},
          {'start':1039, 'article':15, 'element':'#fowtr-article15 h4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Recap'},
          {'start':1048.471042, 'article':15, 'element':'#fowtr-article15 .ra1', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Recap'},
          {'start':1057.900792, 'article':15, 'element':'#fowtr-article15 .ra2', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Recap'},
          {'start':1072.366479, 'article':15, 'element':'#fowtr-article15 .ra3', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Recap'},
          {'start':1090.659042, 'article':15, 'element':'#fowtr-article15 .ra4', 'navitem':false, 'title':'An Augmented and Automated Future', 'subtitle':'Recap'},

        ];
      }

      if(chapter==4) {
        audioFile = 'https://local.dhl-future-of-work-trend-report.com/audio/DHL-Trend-Report-Chp-4-v1.m4a';
        audioTitle = 'Ways to Prepare for the Future, Today';
        syncData = [
          {'start':0, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':true, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},
          {'start':47.67491667, 'article':1, 'element':'#fowtr-article1 h1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},
          {'start':50.91979167, 'article':1, 'element':'#fowtr-article1 h2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},

          {'start':64.41145833, 'article':2, 'element':'#fowtr-article2 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},
          {'start':76.77022917, 'article':2, 'element':'#fowtr-article2 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},

          {'start':109.8033333, 'article':4, 'element':'#fowtr-article4 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},
          {'start':134.949125, 'article':4, 'element':'#fowtr-article4 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Introduction'},
          {'start':160.0799792, 'article':4, 'element':'#fowtr-article4 h2', 'navitem':true, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Three Levers of Success'},

          {'start':163.569125, 'article':5, 'element':'#fowtr-article5 a:first-child', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Three Levers of Success'},
          {'start':166.2731667, 'article':5, 'element':'#fowtr-article5 a:nth-child(2)', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Three Levers of Success'},
          {'start':168.65675, 'article':5, 'element':'#fowtr-article5 a:nth-child(3)', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Three Levers of Success'},

          {'start':173.0222917, 'article':6, 'element':'#fowtr-article6 h3', 'navitem':true, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':176, 'article':6, 'element':'#fowtr-article6 h4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':180.103625, 'article':6, 'element':'#fowtr-article6 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':197.0386458, 'article':6, 'element':'#fowtr-article6 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          {'start':211.7022292, 'article':7, 'element':'#fowtr-article7 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':220.1916875, 'article':7, 'element':'#fowtr-article7 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':245.4643125, 'article':7, 'element':'#fowtr-article7 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':260.9713333, 'article':7, 'element':'#fowtr-article7 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          {'start':275.0273333, 'article':8, 'element':'#fowtr-article8 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':287.3103958, 'article':8, 'element':'#fowtr-article8 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':309.0806458, 'article':8, 'element':'#fowtr-article8 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          {'start':320.1995208, 'article':9, 'element':'#fowtr-article9 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':327.1811042, 'article':9, 'element':'#fowtr-article9 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':359.2621458, 'article':9, 'element':'#fowtr-article9 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          // slider
          {'start':374, 'article':10, 'element':'#fowtr-article10 .fowtr-slide1 h3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles', 'action':function(){
            fowtr_module_chapter_4.slider.goTo(0);
          }},
          {'start':377.382, 'article':10, 'element':'#fowtr-article10 .fowtr-slide1 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':388.5548542, 'article':10, 'element':'#fowtr-article10 .fowtr-slide1 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':397.4779375, 'article':10, 'element':'#fowtr-article10 .fowtr-slide1 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':402.5187083, 'article':10, 'element':'#fowtr-article10 .fowtr-slide1 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':409.1887292, 'article':10, 'element':'#fowtr-article10 .fowtr-slide1 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          {'start':424, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 h3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles', 'action':function(){
            fowtr_module_chapter_4.slider.goTo(1);
          }},
          {'start':427.1911458, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':437.2157083, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':446.5950208, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':456, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':464.725125, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':475.2601667, 'article':10, 'element':'#fowtr-article10 .fowtr-slide2 .ra6', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          {'start':485.8303958, 'article':10, 'element':'#fowtr-article10 .fowtr-slide3 h3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles', 'action':function(){
            fowtr_module_chapter_4.slider.goTo(2);
          }},
          {'start':489.7418958, 'article':10, 'element':'#fowtr-article10 .fowtr-slide3 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':518.6408958, 'article':10, 'element':'#fowtr-article10 .fowtr-slide3 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':547.8533542, 'article':10, 'element':'#fowtr-article10 .fowtr-slide3 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          // video
          {'start':556.5222917, 'article':11, 'element':'#fowtr-article11 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':574.1537708, 'article':11, 'element':'#fowtr-article11 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          
          // checklist
          {'start':598.7610833, 'article':12, 'element':'#fowtr-article12 h2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':604.3094167, 'article':12, 'element':'#fowtr-article12 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':611.0248125, 'article':12, 'element':'#fowtr-article12 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},
          {'start':618.1813333, 'article':12, 'element':'#fowtr-article12 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Leadership Approach &amp; Roles'},

          // New Learning & Development
          {'start':624, 'article':13, 'element':'#fowtr-article13 h3', 'navitem':true, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':626.7824583, 'article':13, 'element':'#fowtr-article13 h4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':636.7852708, 'article':13, 'element':'#fowtr-article13 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':670.4150625, 'article':13, 'element':'#fowtr-article13 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},

          {'start':692.854125, 'article':14, 'element':'#fowtr-article14 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':703.1682708, 'article':14, 'element':'#fowtr-article14 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':734.1455625, 'article':14, 'element':'#fowtr-article14 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},


          {'start':771.19625, 'article':15, 'element':'#fowtr-article15 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':780.2231667, 'article':15, 'element':'#fowtr-article15 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':805.0017708, 'article':15, 'element':'#fowtr-article15 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':852.9153125, 'article':15, 'element':'#fowtr-article15 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':880.6746458, 'article':15, 'element':'#fowtr-article15 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},

          {'start':916.6699167, 'article':16, 'element':'#fowtr-article16 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':925.6290833, 'article':16, 'element':'#fowtr-article16 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':966.7256042, 'article':16, 'element':'#fowtr-article16 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':994.9228542, 'article':16, 'element':'#fowtr-article16 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},

          {'start':1042.230438, 'article':17, 'element':'#fowtr-article17 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1052.674313, 'article':17, 'element':'#fowtr-article17 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1072.833479, 'article':17, 'element':'#fowtr-article17 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},

          {'start':1114.987063, 'article':18, 'element':'#fowtr-article18 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1124.591313, 'article':18, 'element':'#fowtr-article18 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1149.774354, 'article':18, 'element':'#fowtr-article18 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1169.97225, 'article':18, 'element':'#fowtr-article18 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1200.543063, 'article':18, 'element':'#fowtr-article18 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},

          // section 19 chart?

          // video
          {'start':1225.003833, 'article':20, 'element':'#fowtr-article20 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          // {'start':1237.743854, 'article':20, 'element':'#fowtr-article20 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
 
          // checklist
          {'start':1254.792396, 'article':21, 'element':'#fowtr-article21 h2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1260.474208, 'article':21, 'element':'#fowtr-article21 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1267.785188, 'article':21, 'element':'#fowtr-article21 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1275.279875, 'article':21, 'element':'#fowtr-article21 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1282.062938, 'article':21, 'element':'#fowtr-article21 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1290.672667, 'article':21, 'element':'#fowtr-article21 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1298.416708, 'article':21, 'element':'#fowtr-article21 .ra6', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},
          {'start':1308.509917, 'article':21, 'element':'#fowtr-article21 .ra7', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Learning &amp; Development'},

          // New Work Models & Environment
          {'start':1316.737188, 'article':22, 'element':'#fowtr-article22 h3', 'navitem':true, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1320.082208, 'article':22, 'element':'#fowtr-article22 h4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1331.468438, 'article':22, 'element':'#fowtr-article22 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1360.878438, 'article':22, 'element':'#fowtr-article22 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},

          {'start':1378.076604, 'article':23, 'element':'#fowtr-article23 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1386.799146, 'article':23, 'element':'#fowtr-article23 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},

          {'start':1438.995313, 'article':24, 'element':'#fowtr-article24 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1450, 'article':24, 'element':'#fowtr-article24 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1480.569583, 'article':24, 'element':'#fowtr-article24 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},

          {'start':1511.061917, 'article':25, 'element':'#fowtr-article25 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1522.781771, 'article':25, 'element':'#fowtr-article25 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1561.975146, 'article':25, 'element':'#fowtr-article25 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1587.344479, 'article':25, 'element':'#fowtr-article25 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},

          {'start':1615.568167, 'article':26, 'element':'#fowtr-article26 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1629.683417, 'article':26, 'element':'#fowtr-article26 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1662.297688, 'article':26, 'element':'#fowtr-article26 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1692, 'article':26, 'element':'#fowtr-article26 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1704.880813, 'article':26, 'element':'#fowtr-article26 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},

          // checklist
          {'start':1742.645479, 'article':27, 'element':'#fowtr-article27 h2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1748.642292, 'article':27, 'element':'#fowtr-article27 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1753.489563, 'article':27, 'element':'#fowtr-article27 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1758.486042, 'article':27, 'element':'#fowtr-article27 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1767.415, 'article':27, 'element':'#fowtr-article27 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},
          {'start':1772.993375, 'article':27, 'element':'#fowtr-article27 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'New Work Models &amp; Environment'},

          // summary
          {'start':1781.146313, 'article':28, 'element':'#fowtr-article28 h3', 'navitem':true, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Summary'},
          {'start':1782.868896, 'article':28, 'element':'#fowtr-article28 .ra1', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Summary'},
          {'start':1798.850771, 'article':28, 'element':'#fowtr-article28 .ra2', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Summary'},
          {'start':1818.460833, 'article':28, 'element':'#fowtr-article28 .ra3', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Summary'},
          {'start':1828.347083, 'article':28, 'element':'#fowtr-article28 .ra4', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Summary'},
          {'start':1847.448792, 'article':28, 'element':'#fowtr-article28 .ra5', 'navitem':false, 'title':'Ways to Prepare for the Future, Today', 'subtitle':'Summary'},

        ];
      }






      // console.log('audio',audioFile);
      // console.log('syncData',syncData);

      // update MP3
      $audio.attr('src',audioFile);

      // init audio state
      audio.removeEventListener("loadedmetadata", fowtr_module_read_aloud.initPlayer, { passive: true });
      // audio.removeEventListener("progress", displayBufferedAmount, { passive: true });
      if (audio.readyState > 0) {
        fowtr_module_audio_player.initPlayer();
      } else {
        audio.addEventListener('loadedmetadata', fowtr_module_read_aloud.initPlayer);
        // audio.addEventListener('progress', displayBufferedAmount);
      }

      // playlist
      playlistInner.html('');
      playlistInner.append('<h4>'+audioTitle+'</h4>');
      for (var i = 0; i < syncData.length; i++) {
        if(syncData[i].navitem) var playlistItem = $('<a href="#" data-playlist-id="'+i+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.42 16.51"><path d="M0,0V16.5L11.42,8.24Z"/></svg><span>'+syncData[i].subtitle+'</span></a>');
        playlistInner.append(playlistItem);
      }

      currentSectionReading = 0;
      audio.currentTime = 0;
      audioPlayerContainer[0].style.setProperty('--buffered-width', "0%");
      audioPlayerContainer[0].style.setProperty('--seek-before-width', "0%");


      //reset
      $('#fowtr-wrapper').removeClass('reading-aloud');
      $('.is-reading').removeClass('is-reading');
      $('.read-aloud').removeClass('read-aloud');
      audioPlayerContainer.removeClass('playing');
      lastElement = null;
      fowtr_module_read_aloud.isPlaying = false;


    };


    fowtr_module_read_aloud.initPlayer = function(){
      // console.log('init');
      //update title
      currentTrackTextElement.html(syncData[0].title + '<br>' + '<span>'+syncData[0].subtitle+'</span>');

      // update timestamp
      durationContainer.html(calculateTime(audio.duration));
      // set slider max
      seekSlider.max = Math.floor(audio.duration);
      seekSlider.value = 0;
    };



    // ===== EVENTS =====
    
    audio.addEventListener('play', started);
    audio.addEventListener('playing', started);
    audio.addEventListener('end', stopped);
    audio.addEventListener('pause', stopped);

    // progress - Fires when the browser is downloading the audio/video
    // audio.addEventListener('progress', displayBufferedAmount);

    // ended
    audio.addEventListener('ended', function(){
     cancelAnimationFrame(raf);
     audioPlayerContainer.removeClass('playing');
    });




      // var totalListeningTime = 0;
      // var totalListeningTimeTimer = setInterval(function(){
      //   if(fowtr_module_read_aloud.isPlaying) {
      //     totalListeningTime ++;
      //     // console.log('total listening time: ',totalListeningTime);
      //   }
      // }, 1000);


      // =================== UDPATE LOOP ===============================

      audio.addEventListener("timeupdate", function(e){
        if(!fowtr_module_read_aloud.isPlaying) return;
        for (var i = 0; i < syncData.length; i++) {
          var startTime = syncData[i].start - 1;
          var endTime = audio.duration;
          if(syncData[i+1]!==undefined) endTime = syncData[i+1].start - 1;
          if( audio.currentTime >= startTime && audio.currentTime <= endTime ) {
            el = syncData[i].element;
            if(el===lastElement) break;
            focusOn($('#fowtr-chapter'+currentChapter+' '+el),i);
            currentSectionReading = i;
            lastElement = el;
            break;
          }
        }
        // console.log('total listening time: ',totalListeningTime);
      });


      audio.addEventListener("play", function(e){
        startPlayback();
      });
      audio.addEventListener("ended", function(e){
        reset();
      });
      audio.addEventListener("pause", function(e){
        reset();
      });

      function startPlayback(){
        if(!fowtr_module_read_aloud.autoScroll) return;
        $('#fowtr-wrapper').addClass('reading-aloud');
        openPlaybar();
        for (var i = 0; i < syncData.length; i++) {
            el = syncData[i].element;
            $('#fowtr-chapter'+currentChapter+' '+el).addClass('read-aloud');
        }
        currentTrackTextElement.html('');
        fowtr_module_read_aloud.isPlaying = true;
        focusOn($('#fowtr-chapter'+currentChapter+' '+syncData[currentSectionReading].element),currentSectionReading);
      }


      function reset(){
        $('#fowtr-wrapper').removeClass('reading-aloud');
        $('.is-reading').removeClass('is-reading');
        $('.read-aloud').removeClass('read-aloud');
        lastElement = null;
        // currentTrackTextElement.html('');
        fowtr_module_read_aloud.isPlaying = false;
        // console.log('total listening time: ',totalListeningTime);
      }

      function focusOn(element,i){
        currentTrackTextElement.html(syncData[i].title + '<br>' + '<span>'+syncData[i].subtitle+'</span>');
        //update playlist active
        if(syncData[i].navitem){
          playlistInner.find('a').removeClass('playing');
          playlistInner.find('a[data-playlist-id="'+i+'"]').addClass('playing');
        }
        if(!fowtr_module_read_aloud.autoScroll) return;
        
        // console.log(fowtr_module_read_aloud.isPlaying);
        if(fowtr_module_read_aloud.isPlaying){
          $('.is-reading').removeClass('is-reading');
          element.addClass('is-reading');
        }
        scrollToElement(element);
        // console.log('syncData[i].action',syncData[i].action);
        if (typeof syncData[i].action === 'function') {
          syncData[i].action();
        }
      }


      function scrollToElement(element) {
        if(!fowtr_module_read_aloud.autoScroll) return;
        // console.log('element',element);
        if(element.length==0) return false;
        var offset = 56+52; // with secondary nav
        offset += 50; // allow for black trend nav bar
        offset += 50; // some offset

        var sectionToGoTo = element;

        if(sectionToGoTo.hasClass('with6pinned')){
          // offset = 218+52; // with secondary nav
          offset = (108 + 106); // without secondary nav
        }

        if($(window).width() < 768){
          offset = (56 + 98);
        }
        
        if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
          offset = 0;
          if(sectionToGoTo.hasClass('with6pinned')){
            offset = 106;
          }
        }



        // middle
        var elHeight = element.height();
        var screenHeight = $(window).height();
        var middleOffset = (screenHeight/2) - (elHeight/2);
        if(middleOffset>0) offset = middleOffset;

        TweenMax.to($('html, body'),0.8,{scrollTop:element.offset().top-offset,ease:Power2.easeInOut});
      }

      // autoScroll
      autoScrollToggle.on('change, input', function(event) {
        event.preventDefault();
        // autoScroll = $(this).
        if ($(this).is(':checked')) {
          // $(this).attr('value', 'true');
          fowtr_module_read_aloud.autoScroll = true;
          if(fowtr_module_read_aloud.isPlaying){
            startPlayback();
          }
        } else {
          // $(this).attr('value', 'false');
          fowtr_module_read_aloud.autoScroll = false;
          if(fowtr_module_read_aloud.isPlaying){
            reset();
            fowtr_module_read_aloud.isPlaying = true;
            // $('#fowtr-wrapper').removeClass('reading-aloud');
            // $('.is-reading').removeClass('is-reading');
            // $('.read-aloud').removeClass('read-aloud');
          }
        }
        console.log('autoscroll',fowtr_module_read_aloud.autoScroll);
      });


      // previous 
      audioPlayerContainer.on('click', '.previous', function(event) {
        event.preventDefault();
        // console.log('currentSectionReading',currentSectionReading);
        if(currentSectionReading>0) {
          currentSectionReading --;
          el = syncData[currentSectionReading].element;
          audio.currentTime = syncData[currentSectionReading].start;
          seekSlider.value = Math.floor(audio.currentTime);
          currentTimeContainer.html(calculateTime(seekSlider.value));
          audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
        }
      });

      // next 
      audioPlayerContainer.on('click', '.next', function(event) {
        event.preventDefault();
        // console.log('currentSectionReading',currentSectionReading);
        if(currentSectionReading<syncData.length) {
          currentSectionReading ++;
          el = syncData[currentSectionReading].element;
          audio.currentTime = syncData[currentSectionReading].start;
          seekSlider.value = Math.floor(audio.currentTime);
          currentTimeContainer.html(calculateTime(seekSlider.value));
          audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
        }
      });

      function forceTransition(){
        // forces transition on, caus with it being in nav, the nav jumps
        // but if scrolling up it snaps, down its smooth so have to force
        // on the css to make sure it always transitions
        audioPlayerWrapper.addClass('force');
        setTimeout(function(){
          audioPlayerWrapper.removeClass('force');
        }, 400);
      }

      // close playbar
      function openPlaybar(){
        audioPlayerWrapper.addClass('open');
        forceTransition();
      }
      function closePlaybar(){
        audioPlayerWrapper.removeClass('open');
        forceTransition();
      }
      audioPlayerContainer.on('click', '.fowtr-audio-button.close', function(event) {
        closePlaybar();
        audio.pause();
        reset();
      });



      function playFromArticle(id) {
        for (var i = 0; i < syncData.length; i++) {
          if(syncData[i].article==id) {
            currentSectionReading = i;
            el = syncData[currentSectionReading].element;
            audio.currentTime = syncData[currentSectionReading].start;
            seekSlider.value = Math.floor(audio.currentTime);
            currentTimeContainer.html(calculateTime(seekSlider.value));
            audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
            audio.play();
            break;
          }
        }
      }

      // read section aloud
      $('#fowtr-wrapper').on('click', '.fowtr-read-section-aloud', function(event) {
        event.preventDefault();
        var article = $(this).parent().attr('id').replace('fowtr-article','');
        console.log('playback article',article);
        playFromArticle(article);
        // for (var i = 0; i < syncData.length; i++) {
        //   if(syncData[i].article==article) {

        //     currentSectionReading = i;
        //     el = syncData[currentSectionReading].element;
        //     audio.currentTime = syncData[currentSectionReading].start;
        //     seekSlider.value = Math.floor(audio.currentTime);
        //     currentTimeContainer.html(calculateTime(seekSlider.value));
        //     audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
        //     audio.play();
        //     break;
        //   }
        // }
      });



      // seek bar - on change
      $seekSlider.on('input', function(e) {
          isScrubbing = true;
          currentTimeContainer.html(calculateTime(seekSlider.value));
          if(audio.paused) {
            currentTimeContainer.html(calculateTime(seekSlider.value));
            audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
          }
      });

      // end changed
      $seekSlider.on('change', function(e) {
          isScrubbing = false;
          audio.currentTime = seekSlider.value;
          seekSlider.value = Math.floor(audio.currentTime);
          currentTimeContainer.html(calculateTime(seekSlider.value));
          audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
      });

      // play pause
      audioPlayerContainer.on('click', '.play', function(event) {
        event.preventDefault();
        if(audio.paused) {
          audio.play();
        } else {
          audio.pause();
        }
      });

      // mute unmute
      audioPlayerContainer.on('click', '.volume a', function(event) {
        event.preventDefault();
        if(!audio.muted) {
            audio.muted = true;
            audioPlayerContainer.addClass('muted');
        } else {
            audio.muted = false;
            audioPlayerContainer.removeClass('muted');
        }
      });

      // volume
      audioPlayerContainer.on('mouseenter', '.volume', function(event) {
        $(this).addClass('open');
      });
      audioPlayerContainer.on('mouseleave', '.volume', function(event) {
        $(this).removeClass('open');
      });
      // volume slider on change
      volumeSlider.on('input', function(e) {
        var value = e.target.value;
        // outputContainer.textContent = value;
        audio.volume = value / 100;
        audioPlayerContainer[0].style.setProperty('--volume-before-width', e.target.value / e.target.max * 100 + '%');
      });




      // =================== nav read aloud ===============================

      // main nav button
      $('#fowtr-wrapper').on('click', '#fowtr-navigation .fowtr-read-aloud', function(event) {
        event.preventDefault();
        if(fowtr_module_utilities.isMobile !== true && $(window).width()>768) openPlaybar();
      });
      // hover
      $('#fowtr-wrapper').on('mouseenter', '#fowtr-navigation .fowtr-read-aloud, #fowtr-navigation .fowtr-read-from', function(event) {
        $('#fowtr-navigation .fowtr-read-from').addClass('open');
      }).on('mouseleave', '.fowtr-read-aloud, .fowtr-read-from', function(event) {
        $('#fowtr-navigation .fowtr-read-from').removeClass('open');
      });
      // playback buttons
      // from current position
      $('#fowtr-wrapper').on('click', '#fowtr-navigation .from_current', function(event) {
        event.preventDefault();
        $('#fowtr-navigation .fowtr-read-from').removeClass('open');
        // openPlaybar();
        var closestArticle = getArticleClosestToCenter();
        playFromArticle(closestArticle);
      });
      // from start
      $('#fowtr-wrapper').on('click', '#fowtr-navigation .from_start', function(event) {
        event.preventDefault();
        $('#fowtr-navigation .fowtr-read-from').removeClass('open');
        // openPlaybar();
        currentSectionReading = 0;
        el = syncData[currentSectionReading].element;
        audio.currentTime = 0;
        seekSlider.value = 0;
        currentTimeContainer.html('0:00');
        audioPlayerContainer[0].style.setProperty('--seek-before-width', "0%");
        audio.play();
      });

      function getArticleClosestToCenter(){
        var mid = $(window).height() / 2;
        var scrollTop = $(document).scrollTop();
        mid = mid+scrollTop;
        // console.log('mid',mid);
        var closest = 999999;
        var closestArticle = 0;
        $.each($('#fowtr-wrapper article > div'), function(index, val) {
          if(typeof $(this).attr('id') !== 'undefined'){
            var articleId = $(this).attr('id');
            if(articleId.indexOf('fowtr-article')!=-1){
              articleId = articleId.replace('fowtr-article','');
              var rect = $(this)[0].getBoundingClientRect();
              var elMid = (rect.top + ((rect.bottom - rect.top)/2)) + scrollTop;
              // console.log('article'+articleId+' elMid',elMid);
              var dist = Math.abs(elMid - mid);
              // console.log('dist',dist);
              if(dist < closest) {
                closest = dist;
                closestArticle = articleId;
              }
            }
          }
        });
        return closestArticle;
      }

      // scroll section in view - play this section - throttled/debounce
      var scrollEvent = fowtr_module_utilities.debounce(function(){
        var closestArticle = getArticleClosestToCenter();
        // console.log(closestArticle);
        if(closestArticle > 1) {
          $('#fowtr-navigation .fowtr-read-from').addClass('scrolled');
        } else {
          $('#fowtr-navigation .fowtr-read-from').removeClass('scrolled');
        }
      },300);
      window.onscroll = scrollEvent;
      scrollEvent();




      // $.each($('#fowtr-wrapper .fowtr-analytics-view-trigger'), function(index, val) {
      //   // event.stopPropagation();
      //   // if(!$(event.target).is(this)) return;
      //   $(this).on('inview', function(event, visible) {
      //     if (visible) {
      //       console.log('section');
      //     }
      //   });
      // });


      // =================== footer playlist ===============================



      audioPlayerContainer.on('click', 'a.playlist', function(event) {
        event.preventDefault();
        if(!playlistContainer.hasClass('open')){
          playlistContainer.addClass('open');
          $(this).addClass('open');
        } else {
          playlistContainer.removeClass('open');
          $(this).removeClass('open');
        }
      });
      audioPlayerContainer.on('click', 'a.close', function(event) {
          event.preventDefault();
          playlistContainer.removeClass('open');
          $('#fowtr-read-aloud-playbar-wrapper .fowtr-read-aloud-playbar a.playlist').removeClass('open');
      });
      playlistInner.on('click', 'a', function(event) {
        event.preventDefault();
        var i = $(this).attr('data-playlist-id');

        currentSectionReading = i;
        el = syncData[i].element;
        audio.currentTime = syncData[i].start;
        seekSlider.value = Math.floor(audio.currentTime);
        // currentTimeContainer.html(calculateTime(seekSlider.value));
        // audioPlayerContainer[0].style.setProperty('--seek-before-width', (seekSlider.value / seekSlider.max * 100)+"%");
        audio.play();
        
        playlistContainer.removeClass('open');
        $('#fowtr-read-aloud-playbar-wrapper .fowtr-read-aloud-playbar a.playlist').removeClass('open');

      });










      /* Implementation of the Media Session API */
      if('mediaSession' in navigator) {
        // console.log('mediaSession enabled');
          navigator.mediaSession.metadata = new MediaMetadata({
              title: 'Future of Work Trend Report',
              artist: 'DHL',
              // album: 'Future of Work Trend Report',
              artwork: [
                  { src: 'https://local.dhl-future-of-work-trend-report.com/images/audio-artwork.jpg', sizes: '96x96', type: 'image/jpg' },
                  { src: 'https://local.dhl-future-of-work-trend-report.com/images/audio-artwork.jpg', sizes: '128x128', type: 'image/jpg' },
                  { src: 'https://local.dhl-future-of-work-trend-report.com/images/audio-artwork.jpg', sizes: '192x192', type: 'image/jpg' },
                  { src: 'https://local.dhl-future-of-work-trend-report.com/images/audio-artwork.jpg', sizes: '256x256', type: 'image/jpg' },
                  { src: 'https://local.dhl-future-of-work-trend-report.com/images/audio-artwork.jpg', sizes: '384x384', type: 'image/jpg' },
                  { src: 'https://local.dhl-future-of-work-trend-report.com/images/audio-artwork.jpg', sizes: '512x512', type: 'image/jpg' }
              ]
          });
          navigator.mediaSession.setActionHandler('play', function() {
          // console.log('mediaSession play');
              if(playState === 'play') {
                  audio.play();
                  // playAnimation.playSegments([14, 27], true);
                  requestAnimationFrame(whilePlaying);
                  playState = 'pause';
                  audioPlayerContainer.addClass('playing');
              } else {
                  audio.pause();
                  // playAnimation.playSegments([0, 14], true);
                  cancelAnimationFrame(raf);
                  playState = 'play';
                  audioPlayerContainer.removeClass('playing');
              }
          });
          navigator.mediaSession.setActionHandler('pause', function() {
          // console.log('mediaSession pause');
              if(playState === 'play') {
                  audio.play();
                  // playAnimation.playSegments([14, 27], true);
                  requestAnimationFrame(whilePlaying);
                  playState = 'pause';
                  audioPlayerContainer.addClass('playing');
              } else {
                  audio.pause();
                  // playAnimation.playSegments([0, 14], true);
                  cancelAnimationFrame(raf);
                  playState = 'play';
                  audioPlayerContainer.removeClass('playing');
              }
          });
          navigator.mediaSession.setActionHandler('seekbackward', function(details) {
              audio.currentTime = audio.currentTime - (details.seekOffset || 10);
          });
          navigator.mediaSession.setActionHandler('seekforward', function(details) {
              audio.currentTime = audio.currentTime + (details.seekOffset || 10);
          });
          navigator.mediaSession.setActionHandler('seekto', function(details) {
              if (details.fastSeek && 'fastSeek' in audio) {
                audio.fastSeek(details.seekTime);
                return;
              }
              audio.currentTime = details.seekTime;
          });
          navigator.mediaSession.setActionHandler('stop', function() {
          // console.log('mediaSession stop');
              audio.currentTime = 0;
              seekSlider[0].value = 0;
              audioPlayerContainer[0].style.setProperty('--seek-before-width', '0%');
              currentTimeContainer.html('0:00');
              if(playState === 'pause') {
                  // playAnimation.playSegments([0, 14], true);
                  cancelAnimationFrame(raf);
                  playState = 'play';
                  audioPlayerContainer.removeClass('playing');
              }
          });
      }


    return fowtr_module_read_aloud;
}(fowtr_module_read_aloud || {}));